<template>
  <div class="deposit-bar-container">
    <div class="deposit-limit-bar" :class="{'hide-arrow-link': hideArrowLink}">
      

      <div>
          <svg-icon class="bar-icon" icon-name="safebox"/>
      </div>
      <div>
          <div class="type-title"><span class="txt-highlight"> {{ currentDepositType.label }}</span></div>

          <!-- unlimited layout (since it is not comes from the backend) -->
          <!-- not used for now because it was requested not to show bar at all in this case -->
          <div v-if="isUnlimited">
            
            <div class="bar-wr">
              <div class="bar-line" :class="{ 'over-deposit': isOverDeposit }">
                <div class="bar-inner">
                  <div class="bar-part to-deposit" :style="{ width:  '100%'}"></div>
                </div>
              </div>
            </div>
            <div  class="bar-info">
              <div> <span class="txt-highlight">&infin;</span></div>
            </div>
          </div>

          <div v-else>
            <div class="bar-info">
              <div> <span class="txt-highlight">{{ CURRENCY.symbol }}{{ amountUsedStr }}</span> / {{ CURRENCY.symbol }}{{ amountMaxStr }}</div>
              <div>Remaining: {{ CURRENCY.symbol }}{{ amountRemainingStr }}</div>
            </div>
            <div class="bar-wr">
              <div class="bar-line" :class="{ 'over-deposit': isOverDeposit }">
                <div class="bar-inner">
                  <div class="bar-part" :style="{ width:  `${widthPercentUsedAmount}%`}"></div>
                  <div class="bar-part to-deposit" :style="{ width:  `${widthPercentToDepositAmount}%`}"></div>
                </div>
              </div>
            </div>
            <div class="bar-info">
              <div v-if="limitPeriod">{{ limitPeriod }} limit</div>
              <div v-if="limitEnd">{{ resetStr }}</div>

            </div>
          </div>
      </div>
      <div v-if="!hideArrowLink">
          <router-link class="" :to="{name:'updateDepositLimit'}">
            <svg-icon class="bar-icon" icon-name="arrow-right"/>
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapGetters } from "vuex";
  import SvgIcon from "@/components/UI/SvgIcon";

  export default {
    name: "DepositLimitBar",
    components: {
      SvgIcon
    },
    props: {
      limitType: {},
      limitPeriod: {},
      limitEnd: {},
      amountMax: {},
      amountRemaining: {},
      amountUsed: { },
      amountToDeposit: {
        default: 0
      },
      isUnlimited: {
        type: Boolean,
        default: false
      },
      hideArrowLink: {
        type: Boolean,
        default: false
      },

    },
    computed:{
      ...mapGetters(['CURRENCY']),


      currentDepositType() {
        if (this.isUnlimited) {
          return { label: 'Unlimited' }
        }
        if (!this.limitType) {
          return { label: '' }
        }
        return this.ENUMS.depositLimitType.find(el => el.id === this.limitType)
      },

      isOverDeposit() {
        return (this.amountRemaining - this.amountToDeposit) < 0;
      },

      widthPercentUsedAmount() {
        if (!this.amountUsed) {
          return 0
        }
        return  ((this.amountUsed / this.amountMax) * 100).toFixed(2)
      },

      widthPercentToDepositAmount() {
        if (!this.amountToDeposit) {
          return 0
        }
        if (this.isOverDeposit) {
          return (100 - this.widthPercentUsedAmount).toFixed(2)
        }
        return ((this.amountToDeposit / this.amountMax) * 100).toFixed(2)
      },

      resetStr() {
        return `Resets: ${moment(this.limitEnd).format("D.M.YYYY, HH:mm")}`;
      },

      amountMaxStr() {
        return this.moneyFormat(this.amountMax)
      },
      amountRemainingStr() {
        return this.moneyFormat(this.amountRemaining)
      },
      amountUsedStr() {
        return this.moneyFormat(this.amountUsed)
      }
      
    },

    methods: {
      moneyFormat(val) {
        // int 99 -> 99 (as is), float 99.9 -> 99.90 (two marks after comma)
        return val % 1 === 0 ? val : parseFloat(val)?.toFixed(2)
      }
    }
  }
</script>

<style scoped lang="scss">
  .deposit-bar-container {
    container-type: inline-size;
    .deposit-limit-bar {
      font-size: 0.875rem;
      display: grid;
      grid-template-columns: 2rem 1fr 1.5rem;
      gap: 1rem;
      align-items: center;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
      
      background-color: var(--geoff-bg-main);

      // to avoid overlapping for small width (screem)
      @container (width < 380px) {
        gap: 0.5rem;
        padding: 0.75rem 0.5rem;
      }

      // to avoid overlapping for really small width
      @container (width < 350px) {
        font-size: 0.75rem;
        gap: 0.5rem;
        padding: 0.75rem 0.5rem;
      }


      

      &.hide-arrow-link {
        grid-template-columns: 2rem 1fr;
      }


      .type-title {
        margin-bottom: 0.5rem;
      }

      .txt-highlight {
        font-size: 1rem;
        font-weight: 700;
      }
      .txt-unlimited {
        font-size: 1.5rem;
        line-height: 1;
        font-weight: 700;
      }
      
      .bar-icon {
        color: var(--geoff-accent);
        height: 2rem;
      }

      .bar-info {
        display: flex;
        gap: 1rem;
        justify-content: space-between;

        
      }

      .bar-wr {
        margin: 0.25rem 0;

        .bar-line {
          height: 0.375rem;
          width:100%;
          border-radius: 50px;
          position: relative;
          background-color: var(--geoff-deposit-bar-bg-1);
          overflow: hidden;

          .bar-inner {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            
            float: left;
            display: flex;
            gap: 0;

            .bar-part {
              height: 100%;
              display: inline-block;
              margin: 0;
              padding: 0;
              background-color: var(--geoff-deposit-bar-bg-2);
              transition: width 0.2s ease;

              &.to-deposit {
                background: repeating-linear-gradient(
                  to right,
                  var(--geoff-deposit-bar-bg-3),
                  var(--geoff-deposit-bar-bg-3) 6px,
                  var(--geoff-deposit-bar-bg-2) 6px,
                  var(--geoff-deposit-bar-bg-2) 12px
                );
              }
            }
          }

          &.over-deposit {
            .bar-inner {

              .bar-part {
                background-color: var(--geoff-deposit-bar-bg-error-1);

                &.to-deposit {
                  background: repeating-linear-gradient(
                    to right,
                    var(--geoff-deposit-bar-bg-error-2),
                    var(--geoff-deposit-bar-bg-error-2) 6px,
                    var(--geoff-deposit-bar-bg-error-1) 6px,
                    var(--geoff-deposit-bar-bg-error-1) 12px
                  );
                }
              }
            }

          }
        }
      }

    }
  }
</style>